@if (context$ | async; as context) {
  <div class="layout-col full bg-background">
    <elder-single-pane-wrapper>
      <elder-pane-header>
        <elder-pane-title>{{ 'layout.connection' | translate }}</elder-pane-title>
      </elder-pane-header>
      <elder-pane-content>
        <form class="flex layout-col">
          <div class="flex layout-row gap-xl">
            <!-- Identification -->
            <div class="flex layout-col">
              <elder-pane-subtitle>{{ 'layout.source' | translate }}</elder-pane-subtitle>
              <div class="layout-row gap-md">
                <mat-form-field>
                  <mat-label>{{ 'layout.source' | translate }}</mat-label>
                  <elder-select
                    name="Source"
                    required
                    placeholder="{{ 'layout.source' | translate }}"
                    [displayPropertyResolver]="nodeNameResolver"
                    [data]="sourceSuggestions"
                    [(value)]="selectedSource"
                    [disabled]="!creationMode"
                    (entityIdChange)="onSourceSelected($event)"
                  >
                  </elder-select>
                </mat-form-field>
              </div>
            </div>
            <div class="flex layout-col">
              <!-- Other -->
              <div class="flex-none layout-col">
                <elder-pane-subtitle>{{ 'layout.targets' | translate }}</elder-pane-subtitle>
                <mat-form-field>
                  <mat-label>{{ 'layout.select-target' | translate }}</mat-label>
                  <elder-select
                    name="add-target"
                    placeholder="{{ 'layout.select-target' | translate }}"
                    [displayPropertyResolver]="targetNameResolver"
                    [data]="targetSuggestions"
                    (entityChange)="onTargetSelected($event)"
                  >
                  </elder-select>
                </mat-form-field>
              </div>
              <div class="flex layout-col">
                <elder-table
                  class="flex outlined"
                  matSort
                  [data]="selectedTargets$ | async"
                  (itemClick)="onTargetEntryClick($event)"
                >
                  <ng-container matColumnDef="transport-duration">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="width: 40%"
                      mat-sort-header="transportCost.duration"
                    >
                      {{ 'layout.transport-duration' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let target; let i = index">
                      <mat-form-field elderDense class="p-sm" subscriptSizing="dynamic">
                        <elder-duration-input
                          [placeholder]="'Initial'"
                          [isoValue]="target?.transportCost?.duration"
                          (valueChange)="onDurationChange(target.node.id, $event)"
                          [format]="'hh:mm'"
                        ></elder-duration-input>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="target-number">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="width: 10%"
                      mat-sort-header="node.workCenter.number"
                    >
                      {{ 'layout.target' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let target">
                      {{ target?.node?.workCenter?.number }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="target-name">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="width: 50%"
                      mat-sort-header="node.workCenter.name"
                    >
                      {{ 'layout.target' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let target">
                      {{ target?.node?.workCenter?.name }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="delete-button">
                    <th mat-header-cell *matHeaderCellDef style="width: 30px">
                      {{ 'actions.delete' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let target">
                      <button mat-icon-button (click)="onDeleteTargetEntry(target)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                </elder-table>
              </div>
            </div>
          </div>
          <div class="flex-none layout-row place-end-stretch">
            <button mat-button (click)="onClose()">
              {{ 'actions.cancel' | translate }}
            </button>
            <button mat-button (click)="onClear()">
              {{ 'layout.clear-targets' | translate }}
            </button>
            <button
              mat-button
              (click)="onApply()"
              [disabled]="!selectedSource || (creationMode && selectedTargets.length === 0)"
            >
              {{ 'actions.apply' | translate }}
            </button>
          </div>
        </form>
      </elder-pane-content>
    </elder-single-pane-wrapper>
  </div>
}
